import React from "react";
import { Route, Switch } from "react-router-dom";
//import { AgencyListing } from "../components/AgencyListing";
//import { ManagingClients } from "../components/ManagingClients";
//import { PricingFees } from "../components/PricingFees";
import { Help } from "../components/Help";


export const HelpPage = () => {
  return (
    <Switch>
      <Route 
        path="/help"
        component={Help}
      />
      {/* 
      <Route
        path="/help/agency-listing"
        component={AgencyListing}
      />            
      <Route
        path="/help/managing-clients"
        component={ManagingClients}
      />
      <Route
        path="/help/pricing-fees"
        component={PricingFees}
      />
      */}
    </Switch>
  );
}